import { render, staticRenderFns } from "./ProgresoMano.vue?vue&type=template&id=95799c2e&scoped=true&"
import script from "./ProgresoMano.vue?vue&type=script&lang=js&"
export * from "./ProgresoMano.vue?vue&type=script&lang=js&"
import style0 from "./ProgresoMano.vue?vue&type=style&index=0&id=95799c2e&prod&lang=scss&scoped=true&"
import style1 from "./ProgresoMano.vue?vue&type=style&index=1&id=95799c2e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95799c2e",
  null
  
)

export default component.exports